var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{staticClass:"catDetailCover"},[_c('div',{staticClass:"bannerText"},[_c('div',{staticClass:"colorBg"},[_c('p',[_vm._v(_vm._s(_vm.$t('RegNPay.Form')))])])])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }